import { http } from '../../http';
import { useCustomConfig } from '@/js/composables/useCustomAxiosRequestConfig';
import type { RequestTestGenesysConnection } from './types';

// silent: the caller shows its own inline success/failure state next to the button, so the
// generic error toast would just be noise on top of that.
export const testGenesysConnection = async (
    request: RequestTestGenesysConnection
): Promise<void> => {
    return http
        .backoffice()
        .post('/genesys/test-connection', request, useCustomConfig({ silent: true }))
        .then(() => undefined);
};
